export default __webpack_public_path__ + "static/media/SalesLost.04bc7f3d.svg";